import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IMultiSpritesConfig, MultiSprites} from "@nolimitcity/slot-game/bin/core/displayobject/MultiSprites";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TimelineLite, TweenLite} from "gsap";
import {FITHGameConfig} from "../../FITHGameConfig";

export class FITHWaysWonGFXText extends BaseView {
    private readonly _wayWonTexts: string[] = ["wayWon", "waysWon"];
    private readonly _maxWidth: number = FITHGameConfig.instance.REEL_AREA_WIDTH * 0.9;
    private readonly _endPositionY: number = 460;
    private _waysWonContainer: PIXI.Container;
    private _waysWonNumber: PIXI.BitmapText;
    private _waysWonText: MultiSprites;
    private _currentTimeline: TimelineLite;

    public showWinWaysWon(winWaysWon: number): void {
        const wayWonText: string = ((winWaysWon === 1) ? this._wayWonTexts[0] : this._wayWonTexts[1]);

        this.completeTimeline();

        const timeline: TimelineLite = new TimelineLite({paused: true});
        timeline.add([
            TweenLite.fromTo(this._waysWonNumber, 0.5, {alpha: 0}, {alpha: 1}),
            this._waysWonText.playSprite(wayWonText,
                {
                    duration: 0.5,
                    vars: [{fromVars: {alpha: 0}, toVars: {alpha: 1}}]
                }),
            () => {
                this._waysWonNumber.text = "" + winWaysWon;
                this._waysWonContainer.scale.set(1);
                this._waysWonContainer.position.set(FITHGameConfig.instance.REEL_AREA_WIDTH / 2, this._endPositionY);
                this.updatePositions(wayWonText);
                if (!this._waysWonContainer.visible) {
                    this._waysWonContainer.visible = true;
                }
            }
        ]);

        this._currentTimeline = timeline;
        this._currentTimeline.play();
    }

    public abort(isAborted: boolean, isBigWin: boolean, winWaysWon: number): void {
        const fadeOutDuration: number = (isBigWin ? 0 : 1);

        this.completeTimeline();

        const wayWonText: string = ((winWaysWon === 1) ? this._wayWonTexts[0] : this._wayWonTexts[1]),
            finishTimeline: TimelineLite = new TimelineLite();
        if (isAborted) {
            finishTimeline.add(() => {
                this._waysWonText.playSprite(wayWonText, {duration: 0, vars: [{toVars: {alpha: 1}}]});
                this._waysWonNumber.text = "" + winWaysWon;
                this._waysWonNumber.alpha = 1;
                this._waysWonContainer.position.set(FITHGameConfig.instance.REEL_AREA_WIDTH / 2, (isBigWin ? this._endPositionY + 160 : this._endPositionY));
                this.updatePositions(wayWonText);
                this._waysWonContainer.visible = true;
            });
        }
        //ending
        finishTimeline.add([
            TweenLite.fromTo(this._waysWonNumber, fadeOutDuration, {alpha: 1}, {alpha: 0}),
            this._waysWonText.playSprite(wayWonText,
                {
                    duration: fadeOutDuration,
                    vars: [{fromVars: {alpha: 1}, toVars: {alpha: 0}}]
                })
        ], `+=1`);

        finishTimeline.add(() => {
            this._waysWonContainer.visible = false;
        });
    }

    protected initAnimations(): void {
        const layer: ScalableLayer = StageManager.getLayer(FITHGameConfig.instance.LAYERS.WIN_COUNT_UP.name);
        this._waysWonContainer = new PIXI.Container();
        layer.addChild(this._waysWonContainer);

        const waysWonConfig: IMultiSpritesConfig = {};
        this._wayWonTexts.forEach((text: string) => {
            waysWonConfig[text] = {
                textures: GameResources.getTextures(`${text}Text`),
                anchor: [0, 0]
            }
        });
        this._waysWonText = new MultiSprites(waysWonConfig);
        this._waysWonContainer.addChild(this._waysWonText);

        this._waysWonNumber = new PIXI.BitmapText("", {
            fontName: "NumbersWaysWon",
            fontSize: 50,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        this._waysWonContainer.addChild(this._waysWonNumber);

        this._waysWonContainer.visible = false;
    }

    private completeTimeline(): void {
        if (this._currentTimeline && this._currentTimeline.isActive()) {
            this._currentTimeline.progress(1);
        }
    }

    private updatePositions(spriteName: string): void {
        this._waysWonNumber.updateTransform();
        const totalWidth: number = this._waysWonNumber.width + this._waysWonText.sprites[spriteName].width;
        this._waysWonNumber.x = -totalWidth / 2;
        this._waysWonNumber.y = -8;
        this._waysWonText.x = this._waysWonNumber.x + this._waysWonNumber.width;

        if (totalWidth * this._waysWonContainer.scale.x > this._maxWidth) {
            const scale: number = MathHelper.roundToDecimals(this._maxWidth / totalWidth, 2);
            this._waysWonContainer.scale.set(scale);
        }
    }
}